<template>
  <el-dialog
    title="Edit Field"
    :visible.sync="dialogVisible"
    width="45%"
    :before-close="handleClose"
    @close="$emit('close')"
  >
    <el-form
      :model="formData"
      label-position="left"
      label-width="100px"
      :rules="rules"
      ref="editForm"
    >
      <el-form-item size="medium" label="Question" prop="title">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item size="medium" label="Field ID" prop="variableName">
        <el-input v-model="formData.variableName"></el-input>
      </el-form-item>
      <el-form-item size="medium" label="Description">
        <el-input v-model="formData.description"></el-input>
      </el-form-item>
      <el-form-item size="medium" label="Default value" v-if="isTextField">
        <el-input v-model="formData.default"> </el-input>
      </el-form-item>

      <el-checkbox v-model="formData.required" v-if="!isCatIrtField">Required</el-checkbox>
      <el-checkbox v-model="formData.readonly" v-if="!isCatIrtField">Read only</el-checkbox>

      <div v-if="isObjectFieldHasEnumProperty(editTarget, variableName)" style="margin-top: 40px">
        <el-divider />
        <el-button type="primary" size="small" @click="addEnum">Add Option</el-button>
        <el-form-item
          :label="`Option ${index + 1}`"
          v-for="(item, index) in modalEnumItems"
          :key="index"
          :prop="enumPropFormValidation(index)"
          :rules="[{ required: true, message: 'Please input field option', trigger: 'blur' }, {}]"
          style="margin-top: 10px"
        >
          <el-input v-model="modalEnumItems[index]" placeholder="Value" @change="changeEnum(index)">
            <template slot="append">
              <i class="el-icon-delete enum_delete" @click="deleteEnum(index)"></i>
            </template>
          </el-input>

          <!-- CAT-IRT -->
          <el-row style="padding-top: 10px" v-if="isCatIrtField">
            <el-col :span="6">&nbsp;&nbsp;CAT-IRT:</el-col>
            <el-col :span="18">
              <!-- OPTION A -->
              <el-form-item label="a" label-width="50px" required>
                <el-input-number
                  placeholder="1.5"
                  controls-position="right"
                  size="small"
                  :precision="2"
                  :step="0.1"
                  v-model="formData.catIrt.options[index].a"
                >
                  <template #prepend>a</template>
                </el-input-number>
              </el-form-item>
              <!-- OPTION B -->
              <el-form-item label="b" label-width="50px" required>
                <el-input-number
                  placeholder="1.5"
                  controls-position="right"
                  size="small"
                  :precision="2"
                  :step="0.1"
                  v-model="formData.catIrt.options[index].b"
                >
                  <template #prepend>a</template>
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <div v-if="!isDependencyModal && isDropdownUI && formData.mapArray.length > 0">
          <el-checkbox v-model="formData.isDependencies">Dependencies</el-checkbox>
        </div>
      </div>

      <div v-if="isCatIrtField" style="padding-top: 20px">
        <el-divider />
        <h4>CAT IRT question values</h4>
        <el-row :gutter="20">
          <el-col :span="12"
            ><el-form-item size="medium" label="'a' value">
              <el-input-number
                v-model="formData.catIrt.a"
                controls-position="right"
                size="small"
                :precision="2"
              ></el-input-number> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item size="medium" label="'b' value">
              <el-input-number
                v-model="formData.catIrt.b"
                controls-position="right"
                size="small"
                :precision="2"
              ></el-input-number> </el-form-item
          ></el-col>
        </el-row>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Cancel</el-button>
      <el-button type="primary" @click="handleSaveChange">Save Draft</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: [
    "form",
    "variableName",
    "dialogVisible",
    "isDependencyModal",
    "editTarget",
    "parentField",
    "setUIOrder",
  ],
  data() {
    const fieldNames = this.form.settings.uiSchema["ui:order"];
    const validateVariableName = (rule, value, callback) => {
      if (value !== this.variableName && fieldNames.includes(value)) {
        callback(new Error("Variable name is already exist."));
      } else {
        callback();
      }
    };

    let dependenciesItems;
    let isDependencies;
    let mapArray;
    let formFieldProperties = _.cloneDeep(this.editTarget.properties[this.variableName]);

    if (!this.editTarget.required) this.editTarget.required = [];

    const isRequired = _.includes(this.editTarget.required, this.variableName);
    const formUiSchema = _.cloneDeep(this.form.settings.uiSchema[this.variableName]);

    if (this.isObjectFieldHasEnumProperty(this.editTarget, this.variableName)) {
      const formEnums =
        this.editTarget.properties[this.variableName].enum ||
        this.editTarget.properties[this.variableName].items.enum;
      mapArray = formEnums.map((item) => {
        return {
          name: item,
          oldData: null,
        };
      });
    }

    if (_.has(this.form.settings.fields.dependencies, this.variableName)) {
      dependenciesItems = this.$parent.getParentFieldDependencies(this.variableName);
      mapArray.forEach((item, index) => {
        item.oldData = _.cloneDeep(dependenciesItems[index]);
      });
      isDependencies = true;
    }

    const kr_options = _.isObject(formFieldProperties.kr_options)
      ? formFieldProperties.kr_options
      : {};

    const catIrt = _.isObject(kr_options.catirt) ? kr_options.catirt : {};
    if (!_.isArray(catIrt.options)) catIrt.options = [];

    return {
      formData: {
        title: formFieldProperties.title,
        variableName: this.variableName,
        required: isRequired,
        readonly: formUiSchema["ui:readonly"] || false,
        enum: formFieldProperties.enum,
        default: formFieldProperties.default,
        description: formFieldProperties.description,
        isDependencies,
        mapArray,
        items: formFieldProperties.items,
        catIrt,
      },
      rules: {
        title: [{ required: true, message: "Please input field label title", trigger: "blur" }],
        variableName: [
          { required: true, message: "Please input field variable name", trigger: "blur" },
          { validator: validateVariableName, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleClose(done) {
      this.$confirm("Are you sure to close this dialog?")
        .then((_) => {
          this.$emit("close");
        })
        .catch((_) => {});
    },
    handleSaveChange() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          // Change variable name in properties and ui order
          this.$emit("changeVariableName", {
            oldName: this.variableName,
            newName: this.formData.variableName,
            dependencyForm: this.editTarget,
            parentField: this.parentField,
          });

          // Set field properties
          this.setFieldProperties(this.editTarget);
          if (this.formData.default?.length === 0) {
            this.$delete(this.editTarget.properties[this.formData.variableName], "default");
          }

          // Set Dependencies
          if (!this.isDependencyModal) {
            this.setDependencies();
          }

          // Set required
          this.setFieldRequired();

          // Set readonly
          this.$set(
            this.form.settings.uiSchema[this.formData.variableName],
            "ui:readonly",
            this.formData.readonly
          );

          this.$emit("close");
          this.$emit("setUIOrder");
        } else {
          return false;
        }
      });
    },

    addEnum() {
      if (!this.isDependencyModal) {
        this.formData.mapArray.push({
          name: "Option " + (this.formData.mapArray.length + 1),
          oldData: null,
        });
      }

      if (this.editTarget.properties[this.variableName].type === "array") {
        this.formData.items.enum.push("Option " + (this.formData.items.enum.length + 1));
        return;
      }
      this.formData.enum.push("Option " + (this.formData.enum.length + 1));

      if (this.isCatIrtField) {
        this.formData.catIrt.options.push({});
      }
    },
    deleteEnum(index) {
      this.$confirm("Are you sure to delete this property? ", "Confirmation", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        if (!this.isDependencyModal && this.formData.mapArray[index].oldData) {
          const childFields = _.keys(this.formData.mapArray[index].oldData.properties).filter(
            (item) => item !== this.formData.variableName
          );

          childFields.forEach((field) => {
            this.$delete(this.form.settings.uiSchema, field);
          });
        }
        this.formData.mapArray.splice(index, 1);
        if (this.editTarget.properties[this.variableName].type === "array") {
          this.formData.items.enum.splice(index, 1);
          return;
        }
        this.formData.enum.splice(index, 1);

        if (this.isCatIrtField) {
          this.formData.catIrt.options.splice(index, 1);
        }
      });
    },
    setDependencies() {
      const data = this.formData.mapArray;
      if (!_.has(this.form.settings.fields, "dependencies")) {
        this.$set(this.form.settings.fields, "dependencies", {});
      }

      if (data && this.formData.isDependencies) {
        let result;
        result = data.map((item) => {
          const oldPropertiesData = item.oldData ? item.oldData.properties : {};
          const oldRequiredData = item.oldData ? item.oldData.required : [];

          if (!_.isEqual(this.variableName, this.formData.variableName)) {
            this.$delete(oldPropertiesData, this.variableName);
          }

          return {
            properties: {
              ...oldPropertiesData,
              [this.formData.variableName]: {
                enum: [item.name],
              },
            },
            required: oldRequiredData,
          };
        });
        this.$set(this.form.settings.fields.dependencies, this.formData.variableName, {
          oneOf: result,
        });
      } else {
        this.$delete(this.form.settings.fields.dependencies, this.formData.variableName);
      }
    },
    setFieldProperties(form) {
      const fieldProperties = ["title", "enum", "description", "default", "items", "catirt"];
      fieldProperties.forEach((item) => {
        let originProperty = form[item];
        let updateProperty = this.formData[item];

        if (item === "catirt") {
          item = "kr_options";
          originProperty = form.kr_options?.catirt;
          updateProperty = { catirt: this.formData.catIrt };
        }

        if (!_.isEqual(originProperty, updateProperty)) {
          this.$set(form.properties[this.formData.variableName], item, updateProperty);
        }
      });
    },
    setFieldRequired() {
      if (!this.editTarget.required) this.editTarget.required = [];
      const index = _.indexOf(this.editTarget.required, this.variableName);

      if (index !== -1) {
        this.editTarget.required.splice(index, 1);
      }

      if (this.formData.required) {
        this.editTarget.required.push(this.formData.variableName);
      }
    },
    isObjectFieldHasEnumProperty(editTarget, variableName) {
      return (
        _.has(editTarget.properties[variableName], "enum") ||
        editTarget.properties[variableName].type === "array"
      );
    },
    changeEnum(index) {
      if (!this.isDependencyModal) {
        this.formData.mapArray[index].name = this.formData.enum[index];
      }
    },
    enumPropFormValidation(index) {
      return this.formData.enum ? `enum[${index}]` : `items.enum[${index}]`;
    },
  },
  computed: {
    isTextField() {
      const isHasUiWidget = _.has(this.form.settings.uiSchema[this.variableName], "ui:widget");
      if (!isHasUiWidget && !this.isObjectFieldHasEnumProperty(this.editTarget, this.variableName))
        return true;
      return false;
    },
    isDropdownUI() {
      const fieldUi = this.form.settings.uiSchema[this.variableName];
      return !_.has(fieldUi, "ui:widget");
    },
    modalEnumItems() {
      return this.formData.enum || this.formData.items.enum;
    },
    modalCatIrtItems() {
      return this.formData.catIrt;
    },
    isCatIrtField() {
      return this.isObjectFieldHasEnumProperty && this.form.settings?.options?.catirt;
    },
  },
  mounted() {
    if (this.isCatIrtField && this.formData) this.formData.required = true;
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/colors.scss";

.enum_delete {
  cursor: pointer;
}
.enum_delete:hover {
  color: $color-danger;
}
</style>
